import React from "react";
import TelegramText from "../Text/TelegramText";

const TimeSlotCards = ({
  options,
  selectedSlot,
  onChange,
  optionslabel,
  disabledSlots = [],
}) => {
  const handleSlotChange = (slotIndex) => {
    // Don't allow selecting disabled slots
    if (disabledSlots.includes(slotIndex)) {
      return;
    }
    onChange(slotIndex);
  };

  const formatDate = (slotData) => {
    // Handle undefined or null data
    if (!slotData) {
      return {
        date: "Invalid slot",
        time: "",
      };
    }

    // Handle legacy text format: "21 Aug 2025 - 2PM - 7PM"
    if (typeof slotData === "string") {
      const parts = slotData.split(" - ");
      if (parts.length >= 2) {
        return {
          date: parts[0], // "21 Aug 2025"
          time: parts.slice(1).join(" - "), // "2PM - 7PM"
        };
      }
      return {
        date: slotData,
        time: "",
      };
    }

    // Handle new cached format from Redis: { date, timeRange, timeSlotId, ... }
    if (slotData && typeof slotData === "object") {
      // Check for the new cached format with 'date' and 'timeRange' properties
      if (slotData.date && slotData.timeRange) {
        return {
          date: slotData.date, // "19 Sep 2025"
          time: slotData.timeRange, // "3PM-7PM"
        };
      }

      // Handle legacy object format with 'text' property
      if (slotData.text) {
        const parts = slotData.text.split(" - ");
        if (parts.length >= 2) {
          return {
            date: parts[0],
            time: parts.slice(1).join(" - "),
          };
        }
        return {
          date: slotData.text,
          time: "",
        };
      }
    }

    // Fallback for unknown data structure
    console.warn("TimeSlotCards: Unknown slot data structure:", slotData);
    return {
      date: "Invalid slot",
      time: "",
    };
  };

  if (!options || options.length === 0) {
    return (
      <div>
        <TelegramText className={"telegramSubtitle"}>
          {optionslabel}
        </TelegramText>
        <div className="timeslot-container">
          <div className="timeslot-card">
            <div className="date">No slots available</div>
            <div className="time">Please try again later</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <TelegramText className={"telegramSubtitle"}>{optionslabel}</TelegramText>
      <div className="timeslot-container">
        {options.map((slot, index) => {
          // Pass the entire slot object to formatDate to handle different data structures
          const { date, time } = formatDate(slot.text || slot);
          const isSelected = selectedSlot === index;
          const isDisabled = disabledSlots.includes(index);

          return (
            <label
              key={index}
              className={`timeslot-card ${isSelected ? "selected" : ""} ${
                isDisabled ? "disabled" : ""
              }`}
              onClick={isDisabled ? undefined : () => handleSlotChange(index)}
              style={isDisabled ? { cursor: "not-allowed" } : {}}
            >
              <input
                type="radio"
                name="timeslot"
                value={index}
                checked={isSelected}
                onChange={
                  isDisabled ? undefined : () => handleSlotChange(index)
                }
                disabled={isDisabled}
                className="timeslot-radio"
              />
              <div className="date">{date}</div>
              <div className="time">
                {time}
                {isDisabled ? " (Current)" : ""}
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default TimeSlotCards;
